
export const VOCDONI_STARTEGY = 'vocdoni'
